import url from '@/creditflowresearch/Router/urlConstants';
import { getQueryString } from '@framework/router';
import { IQueryParams } from '@/creditflowresearch/domain/vo/IQueryParams';

export const getCategoryUrl = (categoryId: string, query: IQueryParams): string => {
  const path = categoryId === 'all'
    ? url.CREDIT_FLOW_STATS_LIST_ALL
    : `${ url.CREDIT_FLOW_STATS_LIST_BASE }-${ categoryId }`;

  return `${ path }?${ getQueryString(query) }`;
};
